import styled from 'styled-components'

export const VerticalLineStyle = styled.span.attrs({ className: 'vertical-line' })`
  display: flex;
  height: ${({ height }) => (height ? height + 'px' : 'auto')};
  width: ${({ width }) => width + 'px'};
  background: var(--color-${({ color }) => color}) !important;
  margin: ${({ center }) => (center ? 'auto' : 0)};
`
